import styled from 'styled-components';

export const CheckboxRow = styled.div`
  display: flex;
  flex-grow: 1;
`;
